import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsDependenciesLegacyRedirectRoute: InvariantJiraRoute = {
	name: 'arj-settings-dependencies-redirect',
	path: '/secure/PortfolioDependencySettings.jspa',
};
